// extracted by mini-css-extract-plugin
module.exports = {"container":"ox36rJOFl9t9QFi_Csa_"};